
import React, { useState,useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useParams } from "react-router-dom";
import { BsCameraFill } from "react-icons/bs";
import { BsFillCalendar2Fill } from "react-icons/bs";
import useAuth from "../../Hooks/useAuth";
import ProfileCard from "../common/ProfileCard";

const EditorProfile = () => {
  const {data,showDummyImage} = useAuth()
  const [value, onChange] = useState(new Date());
  const [calender, setCalender] = useState(false);
  const {id} = useParams();
  const [updatedData,setUpdatedData] = useState({})
  useEffect(()=>{
    const profile = data.find(info => parseInt(info?.id) === parseInt(id)) 
    setUpdatedData(profile)
  },[data,id,setUpdatedData])
  const location = window.location.href;
  return (
    <section className="profile">
      <div className="profile-banner">
        <img src={require("../../assets/images/common/profile-banner.png")} alt={'profileBanner'} onError={({currentTarget},imageSize='1900X350')=>showDummyImage({currentTarget},imageSize)}/>
        {
          location.includes("edit-profile") && <div className="change-banner">
            <input className="change-banner-file" type="file" />
            <div className="camera-icon">
              <BsCameraFill />
            </div>
        </div>
        }
        
      </div>
      <div className="container">
        <div className="profile-details">
          <div className="profile-left edit-profile">
            {
              updatedData?.category &&  <ProfileCard data={updatedData} />
            }
          </div>
          <div className="profile-editor">
            <form className="profile-edit-form">
              <div className="profile-edit-input">
                <label htmlFor="">Full Name</label>
                <input type="text" defaultValue={updatedData?.profileName} placeholder="Shadhin Lablu" />
              </div>
              <div className="profile-edit-input">
                <label htmlFor="">Date of Birth</label>
                <div className="date-of-birth">
                  <input
                    type="text"
                    placeholder="12 December 1984"
                    value={value}
                  />
                  <button
                    className="calender-btn"
                    onClick={() => setCalender(!calender)}
                    type="button"
                  >
                    <BsFillCalendar2Fill />
                  </button>
                  {calender && (
                    <div className="calendar">
                      <Calendar onChange={onChange} value={value} />
                    </div>
                  )}
                </div>
              </div>
              <div className="profile-gender">
                <label htmlFor="">Gender</label>
                <div className="profile-gender-input">
                  <div className="male">
                    <input type="radio" />
                    <label htmlFor="">Male</label>
                  </div>
                  <div className="female">
                    <input type="radio" />
                    <label htmlFor="">Female</label>
                  </div>
                </div>
              </div>
              <div className="profile-edit-input">
                <label htmlFor="">Email</label>
                <input type="text" placeholder="shadhinnfts@gmail.com" />
              </div>
              <div className="profile-edit-input">
                <label htmlFor="">Mobile Number</label>
                <input type="text" placeholder="+91 93739375382" />
              </div>
              <div className="save-change">
                <input type="submit" value="Save Change" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorProfile;
